import styles from './index.module.scss';

/** Sits on the top edge of the nearest positioned ancestor. */
const LastUsedTag = () => <span className={styles.tag}>Last used</span>;

export default LastUsedTag;
